export const CREATE_EVENT = 'CREATE_EVENT'
export const UPDATE_EVENT = 'UPDATE_EVENT'
export const DELETE_EVENT = 'DELETE_EVENT'
export const SET_WEEKENDS_ENABLED = 'SET_WEEKENDS_ENABLED'
export const SCROLL_BEHAVIOR = 'SCROLL_BEHAVIOR'
export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const UPDATE_PHOTO_PROFILE = 'UPDATE_PHOTO_PROFILE'
export const MENUS = 'MENUS'
export const ROUTES = 'ROUTES'